<template>
  <div class="entity-main-data">
    <div class="item">
      <span class="title">Operación</span>
      <span>{{ transaction.companyOperationId }}</span>
    </div>
    <div class="item">
      <span class="title">Fecha</span>
      <span>{{ transaction.dueDate }}</span>
    </div>
    <div class="item">
      <span class="title">Pago Nro.</span>
      <span>{{ transaction.paymentNumber }}</span>
    </div>
    <div class="item">
      <span class="title">Monto</span>
      <span>CLP {{ formatNumber(transaction.secondaryCurrencyConsignedAmount) }}</span>
    </div>
    <div class="item">
      <button
        v-if="transaction.status == 'TO_AMEND'"
        :id="`enmendar-button-${transaction.paymentNumber}`"
        :data-cy="`enmendar-button-${transaction.paymentNumber}`"
        type="button"
        class="button is-button-primary is-rounded is-small"
        :disabled="isDisabledEnmendarButton"
        @click="enmendar()">
        <span :data-cy="`enmendar-span-${transaction.investorId}`">Enmendar</span>
      </button>
      <span
        v-if="transaction.status == 'TO_AMEND_MANUALLY'">
        <strong>Va a Enmienda Manual</strong>
      </span>
      <div
        id="enmendar-error-title"
        data-cy="enmendar-error-title"
        class="error-message">
        <span v-if="isErrorMessage">{{ isErrorMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { amend } from '@/application/services/api-clients/appraisal';
import { formatNumber } from '@/infrastructure/format';

export default {
  name: 'AppraisalHistoryTransactionItem',
  props: {
    appraisalId: {
      type: String,
      default: '',
      required: true
    },
    transaction: {
      type: Object,
      default: () => {},
      required: true
    },
    pos: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isDisabledEnmendarButton: false,
      isErrorMessage: '',
      result: undefined
    };
  },
  methods: {
    formatNumber: number => formatNumber({ number }),
    async enmendar() {
      try {
        const { companyOperationId, dueDate, investorId, operationId, transactionId } = this.transaction;
        this.result = await amend({ appraisalId: this.appraisalId, companyOperationId, dueDate, investorId, operationId, transactionId });
        this.$emit('updateTransactionStatus', this.pos);
        if (this.result.processingStatus === 'PROCESSED') {
          this.$emit('updateAppraisalStatus', 'PROCESSED');
        }
      } catch (_error) {
        this.isErrorMessage = 'Error, favor reintente.';
      }
    }
  }
};
</script>

<style scoped>
.error-message {
  justify-items: center;
  color: red;
}
.entity-main-data {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
}
.entity-main-data .item {
  display: grid;
  justify-content: stretch;
  margin: 0;
  margin-bottom: .5rem;
}
.entity-main-data .item .title {
  font-size: 0.8rem;
  margin: 0;
}
@media (max-width: 640px) {
  .entity-main-data .item {
    display: block;
    justify-content: stretch;
    margin-bottom: 10px;
  }
  .entity-main-data .item > span {
    margin-left: 5px;
  }
}
</style>
